import api from "@/libs/axios";

const trading = {
    state: {},
    getters: {},
    actions: {
        allocateValueInTrading: ({ commit }, data) => {
            return new Promise(async (resolve, reject) => {
                await api.post('/trader/allocate-value-in-trading', data).then(response => {
                    resolve(response.data)
                }).catch(error => {
                    reject(error.response.data)
                })
            })
        },
        relocateValue: ({ commit }, data) => {
            return new Promise(async (resolve, reject) => {
                await api.post('/trader/relocate-value', data).then(response => {
                    resolve(response.data)
                }).catch(error => {
                    reject(error.response.data)
                })
            })
        },
        withdrawValueTrading: ({ commit }, data) => {
            return new Promise(async (resolve, reject) => {
                await api.post('/trader/robot-withdraw', data).then(response => {
                    resolve(response.data)
                }).catch(error => {
                    reject(error.response.data)
                })
            })
        },
        changeConfigRobot: ({ commit }, config) => {
            return new Promise(async (resolve, reject) => {
                await api.patch('/trader/config-robot-trader', config).then(response => {
                    resolve(response.data)
                }).catch(error => {
                    reject(error.response.data)
                })
            })
        },
        searchConfigRobot: ({ commit }) => {
            return new Promise(async (resolve, reject) => {
                await api.get('/trader/search-config-robot-trader').then(response => {
                    resolve(response.data)
                }).catch(error => {
                    reject(error.response.data)
                })
            })
        },
        signPlanRequest: ({ commit }, data) => {
            return new Promise(async (resolve, reject) => {
                await api.post('/trader/create-deposit-intent', { licenseValue: data.value, product: data.product }).then(response => {
                    resolve(response.data)
                }).catch(error => {
                    reject(error.response.data)
                })
            })
        },
        //DEXBOT ################
        getInfoActivePools: ({ commit }, id) => {
            return new Promise(async (resolve, reject) => {
                await api
                    .get(`/dashboard/dexbot/info-active-pools`)
                    .then((response) => {
                        resolve(response.data);
                    })
                    .catch((error) => {
                        reject(error.response.data.message);
                    });
            });
        },
        getPoolEvolutionGraph: ({ commit }, id) => {
            return new Promise(async (resolve, reject) => {
                await api
                    .get(`/dashboard/dexbot/get-pool-evolution-graph`)
                    .then((response) => {
                        resolve(response.data);
                    })
                    .catch((error) => {
                        reject(error.response.data.message);
                    });
            });
        },
        getWalletBalance: ({ commit }, id) => {
            return new Promise(async (resolve, reject) => {
                await api
                    .get(`/dashboard/dexbot/info-wallet-balance`)
                    .then((response) => {
                        resolve(response.data);
                    })
                    .catch((error) => {
                        reject(error.response.data.message);
                    });
            });
        },
        getParticipationLicensesPool: ({ commit }, id) => {
            return new Promise(async (resolve, reject) => {
                await api
                    .get(`/dashboard/dexbot/participation-licenses-pool`)
                    .then((response) => {
                        resolve(response.data);
                    })
                    .catch((error) => {
                        reject(error.response.data.message);
                    });
            });
        },
        removePool: ({ commit }, id) => {
            return new Promise(async (resolve, reject) => {
                await api
                    .patch(`/dashboard/dexbot/remove-pool`, { poolId: id })
                    .then((response) => {
                        resolve(response.data);
                    })
                    .catch((error) => {
                        reject(error.response.data.message);
                    });
            });
        },
        updatingPools: ({ commit }, status) => {
            return new Promise(async (resolve, reject) => {
                await api
                    .patch(`/dashboard/dexbot/update-pool`, { updatingPools: status })
                    .then((response) => {
                        resolve(response.data);
                    })
                    .catch((error) => {
                        reject(error.response.data.message);
                    });
            });
        },
        searchConfigBotPool: ({ commit }) => {
            return new Promise(async (resolve, reject) => {
                await api
                    .get("/dashboard/pool/bot-config")
                    .then((response) => {
                        resolve(response.data);
                    })
                    .catch((error) => {
                        reject(error.response.data);
                    });
            })
                ;
        },
        changeConfigBotPool: ({ commit }, config) => {
            return new Promise(async (resolve, reject) => {
                await api
                    .patch("/dashboard/pool/bot-config", config)
                    .then((response) => {
                        resolve(response.data);
                    })
                    .catch((error) => {
                        reject(error.response.data);
                    });
            });
        },
        feesDaily: ({ commit }) => {
            return new Promise(async (resolve, reject) => {
                await api
                    .get("/dashboard/fees/daily")
                    .then(response => {
                        resolve(response);  // Resolve diretamente a resposta completa
                    })
                    .catch(error => {
                        reject(error.response.data);
                    });
            });
        },
        getDepositIntent: ({ commit }, data) => {
            return new Promise(async (resolve, reject) => {
                let product = '';

                if (data.planId) {
                    product = 'liquidity_for_pools';
                    data.value = 0;
                } else {
                    product = 'liquidity_pools_license';
                }

                let url = `/trader/get-deposit-intent/${product}/${data.value}`;

                if (data.planId) {
                    url += `/${data.planId}`;
                }

                await api.get(url).then(response => {
                    resolve(response.data);
                }).catch(error => {
                    reject(error.response.data);
                });
            });
        }
    },
    mutations: {},
}

export default trading;